export default __webpack_public_path__ + "static/media/infrastructure.aef1f4f9.webp";